import { render, staticRenderFns } from "./SettingsBtn.vue?vue&type=template&id=44be7654"
import script from "./SettingsBtn.vue?vue&type=script&lang=ts"
export * from "./SettingsBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports